/**
 * File: servicesPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.1.2
 * Created: 2025-12-04
 * Last Updated: 2026-07-26
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";
import GridCard from "../../components/ui/GridCard";

// Services Page
export const servicesPage = {
    meta: {
        id: "services-page",
    },
    hero: {
        image: "./svgs/services_hero_building-isometric-section.svg",
        headline: "MEP Services Designed to Scale Your Team",
        subheadline:
            "Access expert surveying, drafting, engineering, and QA/QC support - delivered on demand, with predictable quality.",
        primaryButton: {
            text: "Get Estimate",
            type: "primary",
        },
        secondaryButton: {
            text: "Send Inquiry",
            type: "secondary",
        },
    },
    gridItems: [
        {
            id: "site-surveying",
            component: GridCard,
            props: {
                header: "SITE SURVEYING",
                subheader: "Actionable field insights",
                description:
                    "Get detailed mechanical and plumbing reports from licensed experts for confident design decisions.",
                buttonText: "Learn More",
                buttonLink: routes.public.services.surveying.abs,
                image: "./svgs/services_surveying_site-plan.svg",
                icon: "./svgs/dropdown_services_surveying-icon.svg",
            },
            modifier: "grid-item--column-span-2",
        },
        {
            id: "drafting",
            component: GridCard,
            props: {
                header: "DRAFTING",
                subheader: "Build-ready documents",
                description:
                    "Work with experienced drafters to produce coordinated, code-compliant construction documents.",
                buttonText: "Learn More",
                buttonLink: routes.public.services.drafting.abs,
                image: "./svgs/services_drafting_hood-section-view.svg",
                icon: "./svgs/dropdown_services_drafting-icon.svg",
            },
            modifier: "grid-item--row-span-2",
        },
        {
            id: "engineering",
            component: GridCard,
            props: {
                header: "ENGINEERING",
                subheader: "Skilled project engineers",
                description:
                    "Add temporary mechanical or plumbing engineers to your team for extra capacity and expertise.",
                buttonText: "Learn More",
                buttonLink: routes.public.services.engineering.abs,
                image: "../svgs/services_engineering_plumbing-isometric.svg",
                icon: "./svgs/dropdown_services_engineering-icon.svg",
            },
            modifier: null,
        },
        {
            id: "qaqc-review",
            component: GridCard,
            props: {
                header: "QA/QC REVIEW",
                subheader: "Prevent costly errors",
                description:
                    "Have licensed PEs review your mechanical and plumbing drawings to catch issues early.",
                buttonText: "Learn More",
                buttonLink: routes.public.services.qaqc.abs,
                image: "../svgs/services_qaqc_mechanical-unit-plan.svg",
                icon: "./svgs/dropdown_services_qaqc-review-icon.svg",
            },
            modifier: null,
        },
    ],
};
